import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Affiliate} from 'src/app/models/affiliate.model';
import {FXResponse} from 'src/app/models/response.model';
import {APP_CONFIG} from 'src/app/shared/common/config';
import {date2String, standardizeParam} from 'src/app/shared/utils/helper';
import { downloadBlob } from 'src/app/shared/utils/export-csv';
import { AccountsModel } from 'src/app/models/accounts.model';
import { MapUtils } from 'src/app/shared/utils/mapper';

@Injectable()
export class IBService {
  // URL to web api.

  constructor(private http: HttpClient) {}

  getAffiliates(params?: any): Observable<FXResponse<Affiliate[]>> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.IB}?${standardizeParam(params)}`)
      .pipe(
        map((res: any) => {
          const data = res.data.ib_list;
          const response = new FXResponse<Affiliate[]>().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((affiliate: any) =>
            MapUtils.deserialize(Affiliate, affiliate)
          );
          return response;
        })
      );
  }
  getTotaTraininglLot(userId:number){
    const url = `${APP_CONFIG.BASE_API_LINK.IB}/total-trading-lot/${userId}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        return response;
      })
    );
  }

  exportAffiliates(params?: any): Observable<void> {
    params = Object.assign(params, {
      is_export: 1
    })
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.IB}?${standardizeParam(params)}`, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        map((res: HttpResponse<Blob>) => {
          let fileName: string = `ib-${date2String(new Date())}.xlsx`;
          downloadBlob(res.body, fileName);
        })
      );
  }
  updateRank(data){
    return this.http
      .put(`${APP_CONFIG.BASE_API_LINK.BONUS}/ib-ranking/custom`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }

  getListChildSpecificByUser(
    userId,
    type,
    params: any
  ): Observable<FXResponse<any[]>> {
    const url = `${
      APP_CONFIG.BASE_API_LINK.IB
    }/${type}/${userId}?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        return response;
      })
    );
  }
  getCampaignListByUser(
    userId,
    params : any
    ): Observable<FXResponse<any[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.IB}/campaign/${userId}?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        response.data.campaignIb = res.data.campaign_ib;
        response.data.campaignUser = res.data.campaign_user;
        return response;
      })
    );
  }

  getGroupListByUser(userId): Observable<FXResponse<any[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.IB}/ib-groups/${userId}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        response.data = res.data.group_configs;
        return response;
      })
    );
  }
  getIBAccountMT4(userId): Observable<FXResponse<AccountsModel[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.IB}/accounts?user_id=${userId}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<AccountsModel[]>().deserialize(res);
        response.data = res.data.accounts.map((account: any) => {
          const c = MapUtils.deserialize(AccountsModel, account);
          return c;
        });
        return response;
      })
    );
  }
  updateRateIb(body): Observable<FXResponse<any[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.IB}/ib-groups`;
    return this.http.post(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        return response;
      })
    );
  }

  getIBChildren(item: any): Observable<FXResponse<any[]>> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.IB}/ib-list/${item.user_id}?page=1&page_size=1000000`)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any[]>().deserialize(res);
          response.data = res.data.ib_list.map((ib: any) => {
            return {

              ...ib,
              type: 1,
              networkLevel: item.networkLevel + 1,
              parentId: item.user_id,
              totalChildren: (ib.total_ib || 0) + (ib.total_trader || 0),
              children: [],
              text: `${ib.first_name || ''} ${ib.last_name || ''}`.trim(),
            };
          });
          return response;
        })
      );
  }

  getUserChildren(item: any): Observable<FXResponse<any[]>> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.IB}/user-list/${item.user_id}?page=1&page_size=1000000`)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any[]>().deserialize(res);
          response.data = res.data.user_list.map((user: any) => {
            return {
              ...user,
              type: 2,
              parentId: item.user_id,
              networkLevel: item.networkLevel + 1,
              totalChildren: 0,
              children: [],
              text: `${user.first_name || ''} ${user.last_name || ''}`.trim(),

            };
          });
          response.total_asset = res.data?.total_asset;
          response.total_lot = res.data?.total_lot;
          response.total_reward = res.data?.total_reward;
          return response;
        })
      );
  }
}
